module.exports = __webpack_public_path__ + "img/YHTXLOGO.f436e45e.png";